module.exports = __webpack_public_path__ + "static/media/dresses.fbec2297.png";